import { render, staticRenderFns } from "./ServicoManter.vue?vue&type=template&id=4dfcc3d3&"
import script from "./ServicoManter.vue?vue&type=script&lang=js&"
export * from "./ServicoManter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports